import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeClientList, resetClientList, openClientList, openWriteMessageModal, clientDeleted } from '../../redux/actions/notificationAction';
import WriteMessageModal from './WriteMessageModal/WriteMessageModal';

import './clientListForNotification.scss';

import TrashIcon from '../../assets/icons/trash.svg'
import CrossIcon from '../../assets/icons/cross.svg'

const ClientsListForNotification = () => {
  const { clients, openClientToNotificationList, showWriteMessageModal } = useSelector(({ notification }) => notification);
  const dispatch = useDispatch();

  const onClientDelete = (id) => {
    const clientIndxToDelete = clients.findIndex(client => client.id === id)

    let newClientsList = [...clients]
    newClientsList.splice(clientIndxToDelete, 1)

    dispatch(changeClientList(newClientsList))
    dispatch(clientDeleted(id))
  }

  const onClientListReset = () => {
    dispatch(resetClientList())
    dispatch(clientDeleted('all'))
  }

  const closeClientsListForNotification = () => {
    dispatch(openClientList(false))
    dispatch(resetClientList())
  }

  const handleOpenMessageModal = () => {
    dispatch(openWriteMessageModal(true))
  }

  return (
    <>
        <div className= {
            openClientToNotificationList
            ? 'notification-list'
            : '' }
        >
            <div className= 'notification-list-row notification-list-row-header' >
                <div>Список клиентов для отправки СМС</div>
                <div>                 
                    <button
                        className="button-icontrigger modal-closetrigger"
                        onClick={() => closeClientsListForNotification()}
                    >
                        <span className="icon">
                            <CrossIcon />
                        </span>
                    </button>
                </div>
            </div>
            <div className= 'notification-list-row'>
                <div className= 'notification-list-clients-count'>{clients.length}</div>
                <div>
                    <button
                        className='button-icontrigger noborder'
                        onClick={() => onClientListReset()}
                    >
                        Очистить список клиентов
                    </button>
                </div>
            </div>
            <div className="notification-list__scrolled">
                <ol>
                    {   clients.map((client, i) => {
                            return (
                                <li key={(client.id)} >
                                    <div className= 'notification-list-row'>
                                        <span className= 'notification-list-row-name'>{client.fullName}</span>
                                        <span>
                                            <button
                                                className='button-icontrigger noborder'
                                                onClick={() => onClientDelete(client.id)}
                                            >
                                                <TrashIcon />
                                            </button>
                                        </span>
                                    </div>
                                </li>
                        )})
                    }
                </ol>
            </div>
            <button 
                type="button" 
                className={ clients.length ?  'button-small' : 'button-small__disabled' }
                onClick={ handleOpenMessageModal }
                disabled ={ clients.length ? false : true}
            >
                Написать СМС
            </button>
        </div>
        {showWriteMessageModal && <WriteMessageModal />}
    </>
  );
};

export default ClientsListForNotification;
